var map = {
	"./symbol_0.png": 82279,
	"./symbol_1.png": 63966,
	"./symbol_2.png": 31317,
	"./symbol_3.png": 62220,
	"./symbol_4.png": 92387,
	"./symbol_5.png": 91162,
	"./symbol_6.png": 4977,
	"./symbol_7.png": 7112,
	"./symbol_8.png": 89375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52322;